import React from "react";
import HeroAlternative from "../../components/HeroAlternative/Hero";
import AlternatingImageText from "../../components/AlternatingImageText/AlternatingImageText";
import Contact from "../../components/Contact/Contact";

export default function ProjectManagement() {
  // Data for AlternatingImageText sections
  const customSections = [
    {
      title: "Project Management Office",
      description: `Establish a center of excellence for project delivery. Our PMO services provide the governance, standards, and tools needed to manage multiple projects efficiently. We help you build scalable processes, ensure consistent reporting, and align all initiatives with your strategic business objectives for maximum ROI.`,
      imageSrc: "/project_management.jpg",
      imageAlt: "Project Management Office dashboard and team collaboration"
    },
    {
      title: "Project Audit",
      description: `Identify risks before they become problems. Our comprehensive project audits assess your current initiatives against best practices. We evaluate scope, schedule, budget, resources, and risks to provide actionable recommendations that get struggling projects back on track or validate that successful ones stay the course.`,
      imageSrc: "/project_audit.jpg",
      imageAlt: "Project audit analysis and reporting"
    },
    {
      title: "Change Management",
      description: `Transform resistance into adaptation. Successful projects require more than technical implementation—they need people to embrace new ways of working. We develop and execute change management strategies that prepare, equip, and support individuals through transitions, ensuring lasting benefits and ROI from your initiatives.`,
      imageSrc: "/change_management.jpg",
      imageAlt: "Team collaboration and change management workshop"
    }
  ];

  return (
    <>
      <HeroAlternative 
        title="Project Management Services"
        subtitle="Strategic Planning. Flawless Execution."
        description="From vision to value - delivered. We provide the expert leadership and structured approach to transform your strategic goals into tangible results. Focus on growing your business while we handle the complexity of delivery—ensuring your projects are completed on time, within scope, and on budget."
        imageSrc="/pexels-cottonbro-7439134.jpg"
        ctaText="Get a Free Consultation"
        ctaLink="/contact"
      />
      
      <AlternatingImageText 
        sections={customSections}
        backgroundColor="light"
      />
      
      <Contact 
        title="Ready to Launch Your Project with Confidence?"
        subtitle="Let's discuss how we can bring clarity and precision to your next initiative. Get a tailored plan for your success."
        ctaText="Schedule a Strategy Call"
      />
    </>
  );
}